<template>
  <div class="app-accessary-footer">
    <SmartLink :route="{ name: 'prime' }">
      <UkaskoLogo />
    </SmartLink>
  </div>
</template>

<script>
import { UkaskoLogo } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  components: { UkaskoLogo, SmartLink },
};
</script>

<style lang="scss" scoped>
.app-accessary-footer {
  padding: 55px;
  background: linear-gradient(0deg, rgba(202, 221, 252, 0.7) 0%, rgba(202, 221, 252, 0) 153.39%);
}
</style>
